import { FC } from 'react'
import { AnalysisCard } from './AnalysisCard'
import classes from './heroSection.module.scss'

interface HeroSectionProps {
  analysisDraft: {
    captionSearch: any
    recentPosts: any
    specificPosts: any
  }
  hasDraftData: boolean
  onCaptionClick: () => void
  onCaptionReviewClick: () => void
  onRecentPostsClick: () => void
  onRecentPostsReviewClick: () => void
  onSpecificPostsClick: () => void
  onSpecificPostsReviewClick: () => void
}

export const HeroSection: FC<HeroSectionProps> = ({
  analysisDraft,
  hasDraftData,
  onRecentPostsClick,
  onRecentPostsReviewClick,
  onSpecificPostsClick,
  onSpecificPostsReviewClick,
  onCaptionClick,
  onCaptionReviewClick,
}) => {
  return (
    <div className={classes.gradientSection}>
      {/* Hero Section */}
      <div className={classes.heroSection}>
        <h1 className={classes.heroTitle}>
          Social Media Analytics Made Simple
        </h1>
        <p className={classes.heroDescription}>
          Analyze any social media page - yours or your competitors&apos;. Get
          insights on post sentiments and stay ahead by <br />
          tracking every move and never miss a beat.
        </p>
      </div>

      {/* Analysis Options Cards */}
      <div className={classes.cardsGrid}>
        <AnalysisCard
          buttonText={
            analysisDraft.recentPosts
              ? 'Edit Recent Posts'
              : 'Analyze Recent Posts'
          }
          description="To analyze a creator's content, simply select their platform links and specify how many of their latest posts you want to review."
          icon={
            <svg fill="none" height="16" viewBox="0 0 24 24" width="16">
              <path
                d="M12 8V12L15 15M21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12Z"
                stroke="currentColor"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="2"
              />
            </svg>
          }
          isChecked={!!analysisDraft.recentPosts}
          onClick={onRecentPostsClick}
          onReviewClick={onRecentPostsReviewClick}
          showReviewButton={!!analysisDraft.recentPosts && hasDraftData}
          title="Recent Posts"
        />

        <AnalysisCard
          buttonText={
            analysisDraft.specificPosts
              ? 'Edit Specific Posts'
              : 'Analyze Specific Posts'
          }
          description="To analyze a creator's content, just enter a variety of links from their profiles across different platforms, order does not matter."
          icon={
            <svg fill="none" height="16" viewBox="0 0 24 24" width="16">
              <circle
                cx="12"
                cy="12"
                r="3"
                stroke="currentColor"
                strokeWidth="2"
              />
              <circle
                cx="12"
                cy="12"
                r="9"
                stroke="currentColor"
                strokeWidth="2"
              />
            </svg>
          }
          isChecked={!!analysisDraft.specificPosts}
          onClick={onSpecificPostsClick}
          onReviewClick={onSpecificPostsReviewClick}
          showReviewButton={!!analysisDraft.specificPosts && hasDraftData}
          title="Specific Posts"
        />

        <AnalysisCard
          buttonText={
            analysisDraft.captionSearch
              ? 'Edit Caption Search'
              : 'Analyze Posts by Caption'
          }
          description="Enter relevant keywords to analyze a creator's content, and the system will collect all related posts."
          icon={
            <svg fill="none" height="16" viewBox="0 0 24 24" width="16">
              <path d="M7 20V4H4V20H7Z" fill="currentColor" />
              <path d="M14 20V4H11V20H14Z" fill="currentColor" />
              <path d="M17 4L21 20H18L14 4H17Z" fill="currentColor" />
            </svg>
          }
          isChecked={!!analysisDraft.captionSearch}
          onClick={onCaptionClick}
          onReviewClick={onCaptionReviewClick}
          showReviewButton={!!analysisDraft.captionSearch && hasDraftData}
          title="Keyword Search"
        />
      </div>
    </div>
  )
}
